import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Clock, Scissors, Search, Trash2 } from 'lucide-react';
export function BonusOne() {
  return <section className="w-full py-16 px-6 border-t" style={{
    backgroundColor: 'white',
    borderColor: 'var(--light-navy)'
  }} data-id="element-155">
      <div className="max-w-2xl mx-auto" data-id="element-156">
        <div className="flex items-center gap-2 mb-8" data-id="element-157">
          <span className="px-3 py-1 rounded text-xs font-bold tracking-wider uppercase" style={{
          backgroundColor: 'var(--navy)',
          color: 'var(--gold)'
        }} data-id="element-158">
            Bono #1
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-159">
          <h2 className="font-serif text-3xl md:text-4xl mb-2" style={{
          color: 'var(--navy)'
        }} data-id="element-160">
            "Reset de Suscripciones en 30 Min (USA)"
          </h2>
          <p className="text-xl font-medium mb-6" data-id="element-161">
            Valor: <span className="line-through opacity-50" data-id="element-162">$47</span> —{' '}
            <span style={{
            color: 'var(--gold)'
          }} data-id="element-163">
              Tuyo GRATIS
            </span>
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/653hpr5H5q6kBYzcK3zp1S/BONO_1_-_RESET_DE_SUSCRIPCIONES_EN_30_MIN_(USA).png" alt="Reset de Suscripciones en 30 Min" className="w-full rounded-xl shadow-lg mb-8" data-id="element-164" />

          <h3 className="font-bold text-xl mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-165">
            El dinero que ya perdiste este mes sin saberlo.
          </h3>
          <p className="text-lg mb-6" style={{
          color: 'var(--charcoal)',
          lineHeight: '1.7'
        }} data-id="element-166">
            Abrí tu app del banco ahora mismo y mirá los últimos 30 días.
            ¿Cuántos cargos repetidos aparecen que no recordás haber autorizado
            conscientemente esta semana?
          </p>
          <p className="text-lg mb-8" style={{
          color: 'var(--charcoal)',
          lineHeight: '1.7'
        }} data-id="element-167">
            Una suscripción de streaming que duplica otra que ya pagás. Una app
            que activaste "de prueba" hace tres meses. Un delivery perk que
            nunca usás. Una renovación anual que se cobró sola.
          </p>
        </motion.div>

        {/* Table */}
        <div className="mb-10 overflow-x-auto" data-id="element-168">
          <table className="w-full text-left border-collapse min-w-[500px]" data-id="element-169">
            <thead data-id="element-170">
              <tr style={{
              borderBottom: '2px solid var(--light-navy)'
            }} data-id="element-171">
                <th className="py-3 font-bold" style={{
                color: 'var(--navy)'
              }} data-id="element-172">
                  Fuga invisible
                </th>
                <th className="py-3 font-bold" style={{
                color: 'var(--navy)'
              }} data-id="element-173">
                  $/mes
                </th>
                <th className="py-3 font-bold" style={{
                color: 'var(--navy)'
              }} data-id="element-174">
                  $/año
                </th>
              </tr>
            </thead>
            <tbody className="text-sm md:text-base" data-id="element-175">
              <tr className="border-b border-gray-100" data-id="element-176">
                <td className="py-3" data-id="element-177">Streaming duplicado</td>
                <td className="py-3" data-id="element-178">$15.99</td>
                <td className="py-3" data-id="element-179">$191.88</td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-180">
                <td className="py-3" data-id="element-181">App olvidada</td>
                <td className="py-3" data-id="element-182">$9.99</td>
                <td className="py-3" data-id="element-183">$119.88</td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-184">
                <td className="py-3" data-id="element-185">Delivery perk sin usar</td>
                <td className="py-3" data-id="element-186">$9.99</td>
                <td className="py-3" data-id="element-187">$119.88</td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-188">
                <td className="py-3" data-id="element-189">Trial que se volvió pago</td>
                <td className="py-3" data-id="element-190">$12.99</td>
                <td className="py-3" data-id="element-191">$155.88</td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-192">
                <td className="py-3" data-id="element-193">Renovación anual olvidada</td>
                <td className="py-3" data-id="element-194">$8.25</td>
                <td className="py-3" data-id="element-195">$99.00</td>
              </tr>
              <tr className="font-bold bg-gray-50" data-id="element-196">
                <td className="py-3 pl-2" data-id="element-197">Total estimado</td>
                <td className="py-3" style={{
                color: 'var(--navy)'
              }} data-id="element-198">
                  $57.21
                </td>
                <td className="py-3" style={{
                color: 'var(--gold)'
              }} data-id="element-199">
                  $686.52
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bg-gray-50 p-6 rounded-xl mb-10" data-id="element-200">
          <h4 className="font-bold text-lg mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-201">
            Cómo funciona:
          </h4>
          <p className="mb-4" data-id="element-202">
            Este bono es un sprint de 30 minutos dividido en 3 bloques:
          </p>

          <div className="space-y-4" data-id="element-203">
            <div className="flex gap-4" data-id="element-204">
              <div className="mt-1" data-id="element-205">
                <Search className="w-5 h-5" style={{
                color: 'var(--gold)'
              }} data-id="element-206" />
              </div>
              <div data-id="element-207">
                <span className="font-bold" data-id="element-208">Min 0–10: Detectar.</span> Revisás 3
                lugares específicos — app del banco, email y suscripciones — con
                una checklist que te guía.
              </div>
            </div>
            <div className="flex gap-4" data-id="element-209">
              <div className="mt-1" data-id="element-210">
                <Scissors className="w-5 h-5" style={{
                color: 'var(--gold)'
              }} data-id="element-211" />
              </div>
              <div data-id="element-212">
                <span className="font-bold" data-id="element-213">Min 10–20: Decidir.</span> Aplicás 3
                reglas simples: 14 días (si no usaste → cancela), Duplicado (se
                queda 1), Anual (si olvidaste → cancela).
              </div>
            </div>
            <div className="flex gap-4" data-id="element-214">
              <div className="mt-1" data-id="element-215">
                <Trash2 className="w-5 h-5" style={{
                color: 'var(--gold)'
              }} data-id="element-216" />
              </div>
              <div data-id="element-217">
                <span className="font-bold" data-id="element-218">Min 20–30: Cerrar.</span> Cancelás
                las primeras 3 fugas con scripts listos en español.
              </div>
            </div>
          </div>
        </div>

        <div className="mb-8" data-id="element-219">
          <h4 className="font-bold text-lg mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-220">
            Lo que incluye:
          </h4>
          <ul className="space-y-3" data-id="element-221">
            <li className="flex gap-3" data-id="element-222">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-223" />
              <span data-id="element-224">
                PDF Mini Guía (12–18 págs) — sistema completo paso a paso
              </span>
            </li>
            <li className="flex gap-3" data-id="element-225">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-226" />
              <span data-id="element-227">Checklist "Caza-Fugas" (printable)</span>
            </li>
            <li className="flex gap-3" data-id="element-228">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-229" />
              <span data-id="element-230">
                Plantilla "Suscripciones & Renovaciones" (Google Sheet)
              </span>
            </li>
            <li className="flex gap-3" data-id="element-231">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-232" />
              <span data-id="element-233">Scripts de cancelación listos en español</span>
            </li>
            <li className="flex gap-3" data-id="element-234">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-235" />
              <span data-id="element-236">Lista Roja de cargos más comunes en USA para 35+</span>
            </li>
          </ul>
        </div>

        <div className="p-6 rounded-xl border border-dashed" style={{
        borderColor: 'var(--navy)',
        backgroundColor: 'var(--light-navy)'
      }} data-id="element-237">
          <p className="font-medium text-center" style={{
          color: 'var(--navy)'
        }} data-id="element-238">
            Si encontrás $47 en suscripciones olvidadas — y casi todo el mundo
            las tiene — este bono pagó el producto entero.
          </p>
        </div>
      </div>
    </section>;
}